import classNames from "classnames";

type RetentionLevel =
  | "not_studied"
  | "weak"
  | "established"
  | "perfect"
  | "studied";

type Props = {
  level: RetentionLevel;
};

type LevelConfig = {
  label: string;
  bgColor: string;
  textColor: string;
  borderColor: string;
  withoutRetentionPrefix?: boolean;
};

const levelConfig: Record<RetentionLevel, LevelConfig> = {
  not_studied: {
    label: "未学習",
    bgColor: "bg-white",
    textColor: "text-gray-600",
    borderColor: "border-gray-600",
    withoutRetentionPrefix: true,
  },
  weak: {
    label: "B",
    bgColor: "bg-white",
    textColor: "text-darkred-500",
    borderColor: "border-darkred-500",
  },
  established: {
    label: "A",
    bgColor: "bg-white",
    textColor: "text-yellow-400",
    borderColor: "border-yellow-400",
  },
  perfect: {
    label: "S",
    bgColor: "bg-white",
    textColor: "text-blue-400",
    borderColor: "border-blue-400",
  },
  studied: {
    label: "完了",
    bgColor: "bg-white",
    textColor: "text-green-400",
    borderColor: "border-green-400",
    withoutRetentionPrefix: true,
  },
};

export const RetentionLevelBadge = ({ level }: Props) => {
  const config = levelConfig[level] ?? levelConfig.not_studied;
  const isPerfect = level === "perfect";
  const withoutRetentionPrefix = config.withoutRetentionPrefix;

  // 定着度プレフィックスなしのスタイル（未学習・完了）
  if (withoutRetentionPrefix) {
    return (
      <div
        className={classNames(
          "flex items-center rounded-[4px] border border-solid px-[10px] py-[2px] leading-[1.3]",
          config.bgColor,
          config.borderColor,
        )}
      >
        <span className={classNames("text-[10px] font-bold", config.textColor)}>
          {config.label}
        </span>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        "flex flex-nowrap items-center gap-[2px] rounded-[4px] border border-solid leading-[1.3]",
        isPerfect ? "px-[5px]" : "px-[4px]",
        config.bgColor,
        config.borderColor,
      )}
    >
      <span
        className={classNames(
          "text-[10px] font-bold whitespace-nowrap",
          config.textColor,
        )}
      >
        定着度
      </span>
      <span
        className={classNames(
          "font-bold text-[14px]",
          "font-[Lato,sans-serif]",
          config.textColor,
        )}
      >
        {config.label}
      </span>
    </div>
  );
};
